import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  IconButton,
  Input,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { BrandingContext } from "../../../BrandingProvider";
import axios from "axios";
import { StyledTextFieldBootstrap } from "../../doctor-console/StyledComponents";
import { toast } from "react-toastify";

const BrandingManagement = () => {
  const brandingData_temp = useContext(BrandingContext);
  const brandingData = !Array.isArray(brandingData_temp)
    ? []
    : brandingData_temp;
  // const brandingData =
  //   typeof brandingData_temp !== "string" ? brandingData_temp : [];
  console.log("brandingData_temp", brandingData_temp);
  // const brandingData =
  //   brandingData_temp.status !== "Failed" ? brandingData_temp : [];
  console.log("branding data", brandingData);
  const client_name = sessionStorage.getItem("customer_name");
  // "facility_name" holds the facility_id slug (set from userInfo.facility_id).
  const facility_id = sessionStorage.getItem("facility_name");
  const [editingField, setEditingField] = useState(null); // To track which field is in edit mode
  const [collateralImage, setCollateralImage] = useState(null);
  const [emailBanner, setEmailBanner] = useState(null);
  const [emailBrandStatement, setEmailBrandStatement] = useState("");
  const [collateralBrandStatement, setCollateralBrandStatement] = useState("");
  const [collateralImageError, setCollateralImageError] = useState("");
  const [themeColour, setThemeColour] = useState("");
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  console.log("editingField", editingField);
  console.log("email brand statement", emailBrandStatement);

  useEffect(() => {
    const collateralImageItem = brandingData?.find(
      (item) => item.name === "collateral_image"
    );
    const existingCollateralImage = collateralImageItem?.content || null;

    const emailBannerItem = brandingData?.find(
      (item) => item.name === "email_banner"
    );
    const existingEmailBanner = emailBannerItem?.content || null;

    const brandingItem = brandingData?.find(
      (item) => item.name === "branding_statements"
    );
    const brandingContent = brandingItem?.content || {};

    // Initial branding data
    const initialEmailBrandStatement =
      brandingContent.emailBrandStatement || "Default Email Statement";
    setEmailBrandStatement(initialEmailBrandStatement);
    const initialCollateralBrandStatement =
      brandingContent.collateralBrandStatement ||
      "Default Collateral Statement";
    setCollateralBrandStatement(initialCollateralBrandStatement);
    const initialThemeColour = brandingContent.themeColour || "#21cdc0";
    setThemeColour(initialThemeColour);
  }, [brandingData_temp]);

  const collateralImageItem = brandingData?.find(
    (item) => item.name === "collateral_image"
  );
  const existingCollateralImage = collateralImageItem?.content || null;

  const emailBannerItem = brandingData?.find(
    (item) => item.name === "email_banner"
  );
  const existingEmailBanner = emailBannerItem?.content || null;

  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || {};

  const handleCollateralImageChange = (event) => {
    const file = event.target.files[0];
    const minSize = 20 * 1024; // 20KB
    const maxSize = 10 * 1024 * 1024; // 10MB

    if (file) {
      // Validate file type
      if (file.type !== "image/png") {
        toast.error("Only PNG files are allowed.");
        setEditingField(null);
        return;
      }

      // Validate file size
      if (file.size < minSize) {
        toast.error("File size must be at least 20KB.");
        setEditingField(null);
        return;
      }
      if (file.size > maxSize) {
        toast.error("File size must not exceed 10MB.");
        setEditingField(null);
        return;
      }

      // If all validations pass
      setCollateralImage(file);
    }
  };

  const handleEmailBannerChange = (event) => {
    const file = event.target.files[0];
    const minSize = 20 * 1024; // 20KB
    const maxSize = 10 * 1024 * 1024; // 10MB

    if (file) {
      // Validate file type
      if (file.type !== "image/png") {
        toast.error("Only PNG files are allowed.");
        setEditingField(null);
        return;
      }

      // Validate minimum file size
      if (file.size < minSize) {
        toast.error("File size must be at least 20KB.");
        setEditingField(null);
        return;
      }

      // Validate maximum file size
      if (file.size > maxSize) {
        toast.error("File size must not exceed 10MB.");
        setEditingField(null);
        return;
      }

      // If all validations pass
      setEmailBanner(file);
    }
  };

  const startEditing = (field) => {
    setEditingField(field);
  };

  const stopEditing = () => {
    setEditingField(null);
  };

  const saveChanges = async () => {
    const formData = new FormData();
    // formData.append("functionality", "branding");
    formData.append("bucket_type", "license");
    formData.append("bucket_category", "conf");
    // client_name / facility_id are optional; send them only when known so the
    // backend falls back to the logged-in user instead of a bogus lookup.
    if (client_name) {
      formData.append("client_name", client_name);
    }
    if (facility_id) {
      formData.append("facility_id", facility_id);
    }

    // Only changed images are uploaded — anything not sent keeps its stored file.
    if (emailBanner) {
      const emailBannerFile = new File([emailBanner], "email_banner.png", {
        type: emailBanner.type,
      });
      formData.append("file_object", emailBannerFile);
    }

    if (collateralImage) {
      const collateralImageFile = new File(
        [collateralImage],
        "collateral_image.png",
        { type: collateralImage.type }
      );
      formData.append("file_object", collateralImageFile);
    }

    // Include branding statements
    const brandingStatements = {
      emailBrandStatement: emailBrandStatement,
      collateralBrandStatement: collateralBrandStatement,
      themeColour: themeColour,
    };

    const brandingStatementsBlob = new Blob(
      [JSON.stringify(brandingStatements)],
      { type: "application/json" }
    );
    const brandingStatementsFile = new File(
      [brandingStatementsBlob],
      "branding_statements.json",
      { type: "application/json" }
    );
    formData.append("file_object", brandingStatementsFile);

    // Log the payload (FormData) for debugging
    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }
    // try {
    //   await axios.post(
    //     `${process.env.REACT_APP_BACKEND_ROUTE_URL}save_facility_branding/`,
    //     formData,
    //     {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //         Authorization: `Bearer ${authToken}`,
    //       },
    //     }
    //   );
    //   toast.success("Branding data uploaded successfully!");
    //   stopEditing(); // Close edit mode on successful save
    // } catch (error) {
    //   console.error("Error uploading branding data:", error);
    // }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}save_facility_branding/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // Handle server response
      if (response.status === 200) {
        const responseData = response.data;
        console.log("Server Response:", responseData);

        // Check if server returned success confirmation
        if (responseData.status === "Success") {
          toast.success(
            responseData.message || "Branding data uploaded successfully!"
          );
          stopEditing();
          window.location.reload(); // Close edit mode on successful save
        } else {
          const message = response.data.message || "An unknown error occurred.";

          if (message.includes("corrupted")) {
            toast.error(
              "The Facility documents uploaded are corrupted. Please try with a different document."
            );
          } else if (message.includes("Virus")) {
            toast.error(
              "The Facility documents uploaded has virus. Please try with a different document."
            );
          } else {
            toast.error(message);
          }
        }
      } else {
        toast.error(`Unexpected response: ${response.status}`);
        console.warn("Unexpected server response:", response);
      }
    } catch (error) {
      // Handle error response
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error("Server Error Response:", error.response);
        toast.error(
          `Error: ${
            error.response.data?.message || "Failed to upload branding data."
          }`
        );
      } else {
        // Something else caused the error
        console.error("Error occurred:", error.message);
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <Box sx={{ padding: 4, maxWidth: "100%", backgroundColor: "#f8f9fa" }}>
      <Grid item xs={12} container justifyContent="center">
        <Typography variant="h4" gutterBottom>
          Branding Management
        </Typography>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "#283b6a;",
              color: "#ffffff", // Ensure text contrast
              padding: "10px 20px",
              borderRadius: "4px",
              marginBottom: "20px",
            }}
          >
            <Typography variant="h5" gutterBottom style={{ color: "#ffffff" }}>
              Branding Data
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            // sx={{
            //   backgroundColor: "#fff",
            //   width: 500,
            //   height: 250,
            //   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
            // }}
            sx={{
              backgroundColor: "#fff",
              // width: 500,
              // height: 250,
              paddingTop: "20px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "scale(1.05) rotateX(5deg) rotateY(5deg)",
                boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
              },
            }}

            // sx={{
            //   backgroundColor: "#fff",
            //   paddingTop: "20px",
            //   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
            //   transition: "transform 0.3s ease, box-shadow 0.3s ease",
            //   "&:hover": {
            //     transform: "scale(1.05) rotateX(5deg) rotateY(5deg)",
            //     boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
            //   },
            // }}
          >
            <CardContent>
              <Typography variant="h6">Email Brand Statement</Typography>
              {editingField === "emailBrandStatement" ? (
                <StyledTextFieldBootstrap
                  fullWidth
                  variant="outlined"
                  value={emailBrandStatement}
                  onChange={(e) => setEmailBrandStatement(e.target.value)}
                />
              ) : (
                <Typography variant="body1">{emailBrandStatement}</Typography>
              )}
            </CardContent>
            <Box display="flex" justifyContent="space-between">
              {editingField === "emailBrandStatement" ? (
                <IconButton onClick={stopEditing}>
                  <CancelIcon />
                </IconButton>
              ) : (
                <IconButton onClick={() => startEditing("emailBrandStatement")}>
                  <EditIcon />
                </IconButton>
              )}
            </Box>
          </Card>
        </Grid>

        {/* Collateral Brand Statement */}

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              backgroundColor: "#fff",
              // width: 500,
              // height: 250,
              paddingTop: "20px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "scale(1.05) rotateX(5deg) rotateY(5deg)",
                boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            <CardContent>
              <Typography variant="h6">Collateral Brand Statement</Typography>
              {editingField === "collateralBrandStatement" ? (
                <StyledTextFieldBootstrap
                  fullWidth
                  variant="outlined"
                  value={collateralBrandStatement}
                  onChange={(e) => setCollateralBrandStatement(e.target.value)}
                />
              ) : (
                <Typography variant="body1">
                  {collateralBrandStatement}
                </Typography>
              )}
            </CardContent>
            <Box display="flex" justifyContent="space-between">
              {editingField === "collateralBrandStatement" ? (
                <IconButton onClick={stopEditing}>
                  <CancelIcon />
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => startEditing("collateralBrandStatement")}
                >
                  <EditIcon />
                </IconButton>
              )}
            </Box>
          </Card>
        </Grid>

        {/* Theme Colour */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              backgroundColor: "#fff",
              // width: 500,
              // height: 250,
              paddingTop: "20px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "scale(1.05) rotateX(5deg) rotateY(5deg)",
                boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            <CardContent>
              <Typography variant="h6">Theme Colour</Typography>
              {editingField === "themeColour" ? (
                <input
                  type="color"
                  value={themeColour} // This will show the current or initial color
                  onChange={(e) => setThemeColour(e.target.value)} // Updates the theme colour in state
                  style={{
                    width: "100%",
                    height: "40px",
                    border: "none",
                    padding: "5px",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <Typography variant="body1">{themeColour}</Typography>
              )}
            </CardContent>
            <Box display="flex" justifyContent="space-between">
              {editingField === "themeColour" ? (
                <IconButton onClick={stopEditing}>
                  <CancelIcon />
                </IconButton>
              ) : (
                <IconButton onClick={() => startEditing("themeColour")}>
                  <EditIcon />
                </IconButton>
              )}
            </Box>
          </Card>
        </Grid>

        {/* Image Section */}
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "#283b6a;",
              color: "#ffffff", // Ensure text contrast
              padding: "10px 20px",
              borderRadius: "4px",
              marginBottom: "20px",
            }}
          >
            <Typography variant="h5" gutterBottom style={{ color: "#ffffff" }}>
              Images
            </Typography>
          </Box>
          <Typography
            variant="subtitle2"
            gutterBottom
            style={{ color: "#555", fontStyle: "italic" }}
          >
            NOTE: The email banner (3000×1000 px) and collateral image (400×100
            px) will be used in customer emails and marketing materials
            respectively. Ensure both reflect your brand and are between 20KB
            and 10MB in size.
          </Typography>
        </Grid>

        {/* Collateral Image */}
        <Grid item xs={12} sm={6}>
          <Card
            sx={{
              backgroundColor: "#fff",
              paddingTop: "20px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "scale(1.05) rotateX(5deg) rotateY(5deg)",
                boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            <CardMedia
              component="img"
              height="200"
              image={`data:image/png;base64,${existingCollateralImage}`}
              alt="Collateral Image"
              sx={{ objectFit: "contain", width: "100%", height: "150px" }}
            />

            <CardContent>
              <Typography variant="h6">Collateral Image</Typography>
              {editingField === "collateralImage" ? (
                <Input type="file" onChange={handleCollateralImageChange} />
              ) : (
                <Typography variant="body1">PNG Image</Typography>
              )}
            </CardContent>

            <Box display="flex" justifyContent="space-between">
              {editingField === "collateralImage" ? (
                <IconButton onClick={stopEditing}>
                  <CancelIcon />
                </IconButton>
              ) : (
                <IconButton onClick={() => startEditing("collateralImage")}>
                  <EditIcon />
                </IconButton>
              )}
            </Box>
          </Card>
        </Grid>

        {/* Email Banner */}
        <Grid item xs={12} sm={6}>
          <Card
            sx={{
              backgroundColor: "#fff",
              paddingTop: "20px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "scale(1.05) rotateX(5deg) rotateY(5deg)",
                boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            <CardMedia
              component="img"
              height="200"
              image={`data:image/png;base64,${existingEmailBanner}`}
              alt="Email Banner"
              sx={{ objectFit: "contain", width: "100%", height: "150px" }}
            />
            <CardContent>
              <Typography variant="h6">Email Banner</Typography>
              {editingField === "emailBanner" ? (
                <Input type="file" onChange={handleEmailBannerChange} />
              ) : (
                <Typography variant="body1">PNG Image</Typography>
              )}
            </CardContent>
            <Box display="flex" justifyContent="space-between">
              {editingField === "emailBanner" ? (
                <IconButton onClick={stopEditing}>
                  <CancelIcon />
                </IconButton>
              ) : (
                <IconButton onClick={() => startEditing("emailBanner")}>
                  <EditIcon />
                </IconButton>
              )}
            </Box>
          </Card>
        </Grid>

        {/* Save and Cancel Buttons */}

        {editingField && (
          <Grid
            container
            sx={{ marginTop: 2, justifyContent: "center", gap: 2 }}
          >
            <Grid item xs={6} sm={3}>
              <button
                type="button"
                className="btn btn__primary btn__rounded btn__block"
                onClick={saveChanges}
              >
                <span>Save</span> <i className="icon-arrow-right"></i>
              </button>
            </Grid>

            <Grid item xs={6} sm={3}>
              <button
                type="button"
                className="btn btn__secondary btn__rounded btn__block"
                onClick={stopEditing}
              >
                <span>Cancel</span> <i className="icon-arrow-right"></i>
              </button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default BrandingManagement;
